import { useContext } from 'react';
import { createDomContext } from '../hooks/dom-context';
export var FormFieldDomContext = createDomContext('form-field-context', {});
function applyDefault(fields, defaults, keys) {
    var result = {};
    keys.forEach(function (key) {
        result[key] = fields[key] === undefined ? defaults[key] : fields[key];
    });
    return result;
}
export function useFormFieldContext(props) {
    var context = useContext(FormFieldDomContext.context);
    return applyDefault(props, context, ['invalid', 'controlId', 'ariaLabelledby', 'ariaDescribedby']);
}
//# sourceMappingURL=form-field-context.js.map